/*
 * @Author: Json Chen
 * @Date: 2021-07-07 14:18:00
 * @LastEditTime: 2021-07-07 17:59:47
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCookies/Components/Reset.tsx
 */

import React from 'react';
import { Menu } from 'antd';
import { DropDown } from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import styles from './styles.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Reset = ({ onReset }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [dropVisible, setDropVisible] = React.useState(false);

  return (
    <span className={styles.dropdown}>
      <DropDown
        visible={dropVisible}
        onVisibleChange={setDropVisible}
        overlay={
          <div className='override'>
            <Menu selectedKeys={[]}>
              <Menu.Item key='resetStyle'>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    onReset();
                    setDropVisible(false);
                  }}
                  style={{ color: '#FF695F' }}>
                  {getI18n('salesChannelCookies.index.resetStyle')}
                </div>
              </Menu.Item>
            </Menu>
          </div>
        }
        trigger={['click']}>
        <Icon
          type='iconMore'
          className={styles.more}
          onClick={(e) => e.stopPropagation()}
        />
      </DropDown>
    </span>
  );
};

export default Reset;
